// eslint-disable-next-line import/prefer-default-export
export const CLEAR_MODAL_FILTER_ID = "#clear-all-modal-filters";
